module.exports = __webpack_public_path__ + "static/media/roundaboutCCW180.abae298e.svg";